<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('accountBond.queryCondition') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            v-model="accountBondInfo.conditions.bondName"
            :placeholder="$t('accountBond.inputBondName')"
            clearable
          />
        </el-col>
        <el-col :span="6">
          <el-select
            v-model="accountBondInfo.conditions.objId"
            :placeholder="$t('accountBond.selectShopType')"
            clearable
          >
            <el-option
              v-for="item in accountBondInfo.shopTypes"
              :key="item.shopTypeId"
              :label="item.typeName"
              :value="item.shopTypeId"
            />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_queryAccountBondMethod">
            {{ $t('accountBond.query') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('accountBond.bondInfo') }}</span>
        <el-button
          type="primary"
          size="small"
          style="float: right"
          @click="_openAddAccountBondModal"
        >
          <i class="el-icon-plus"></i>
          {{ $t('accountBond.add') }}
        </el-button>
      </div>
      <el-table :data="accountBondInfo.accountBonds" border style="width: 100%">
        <el-table-column prop="bondId" :label="$t('accountBond.bondId')" align="center" />
        <el-table-column prop="bondName" :label="$t('accountBond.bondName')" align="center" />
        <el-table-column prop="amount" :label="$t('accountBond.amount')" align="center" />
        <el-table-column prop="bondMonth" :label="$t('accountBond.bondMonth')" align="center" />
        <el-table-column prop="bondName" :label="$t('accountBond.bondType')" align="center" />
        <el-table-column prop="remark" :label="$t('accountBond.remark')" align="center" />
        <el-table-column :label="$t('accountBond.operation')" align="center" width="200">
          <template #default="{row}">
            <el-button size="mini" @click="_openEditAccountBondModel(row)">
              {{ $t('accountBond.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteAccountBondModel(row)">
              {{ $t('accountBond.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="accountBondInfo.conditions.page"
        :page-size="accountBondInfo.conditions.row"
        layout="total, prev, pager, next"
        :total="accountBondInfo.total"
      />
    </el-card>

    <add-account-bond ref="addAccountBond" @refresh="_listAccountBonds" />
    <edit-account-bond ref="editAccountBond" @refresh="_listAccountBonds" />
    <delete-account-bond ref="deleteAccountBond" @refresh="_listAccountBonds" />
  </div>
</template>

<script>
import { queryAccountBond, queryShopType } from '@/api/admin/accountBondApi'
import AddAccountBond from '@/components/admin/accountBond/AddAccountBond'
import EditAccountBond from '@/components/admin/accountBond/EditAccountBond'
import DeleteAccountBond from '@/components/admin/accountBond/DeleteAccountBond'

export default {
  name: 'AccountBond',
  components: {
    AddAccountBond,
    EditAccountBond,
    DeleteAccountBond
  },
  data() {
    return {
      accountBondInfo: {
        accountBonds: [],
        total: 0,
        conditions: {
          bondName: '',
          objId: '',
          page: 1,
          row: 10
        },
        shopTypes: []
      }
    }
  },
  created() {
    this._listAccountBonds()
    this._listAddShopTypes()
  },
  methods: {
    async _listAccountBonds(page = 1, rows = 10) {
      this.accountBondInfo.conditions.page = page
      this.accountBondInfo.conditions.row = rows
      try {
        const res = await queryAccountBond(this.accountBondInfo.conditions)
        this.accountBondInfo.accountBonds = res.data
        this.accountBondInfo.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    async _listAddShopTypes() {
      try {
        const res = await queryShopType({ page: 1, row: 100 })
        this.accountBondInfo.shopTypes = res.data
      } catch (error) {
        console.error(error)
      }
    },
    _openAddAccountBondModal() {
      this.$refs.addAccountBond.open()
    },
    _openEditAccountBondModel(row) {
      this.$refs.editAccountBond.open(row)
    },
    _openDeleteAccountBondModel(row) {
      this.$refs.deleteAccountBond.open(row)
    },
    _queryAccountBondMethod() {
      this._listAccountBonds()
    },
    handleCurrentChange(val) {
      this._listAccountBonds(val)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>